const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M256,0C150.204,0,64.134,85.112,64.134,189.729V459.09c0,4.428,3.589,8.017,8.017,8.017H439.85 c4.427,0,8.017-3.588,8.017-8.017V189.729C447.866,85.112,361.796,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M80.167,451.073V189.729c0-95.776,78.878-173.695,175.833-173.695s175.833,77.919,175.833,173.695 v261.344H80.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62C9CC"
    },
    d: "M256,32.067c-88.114,0-159.8,70.727-159.8,157.662c0,4.428,3.589,8.017,8.017,8.017h303.566 c4.427,0,8.017-3.588,8.017-8.017C415.8,102.793,344.114,32.067,256,32.067z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M400.437,122.322l-74.425,75.423h81.77c4.427,0,8.017-3.588,8.017-8.017 C415.8,165.625,410.281,142.771,400.437,122.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M178.505,197.745h68.409l120.21-121.2c-11.956-11.43-25.709-21.036-40.798-28.363L178.505,197.745z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62C9CC"
    },
    d: "M407.783,215.917H277.378c-4.427,0-8.017,3.588-8.017,8.017v203.09c0,4.428,3.589,8.017,8.017,8.017 h130.405c4.427,0,8.017-3.588,8.017-8.017v-203.09C415.8,219.505,412.21,215.917,407.783,215.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62C9CC"
    },
    d: "M407.783,435.04c4.427,0,8.017-3.588,8.017-8.017v-44.359l-52.376,52.376H407.783z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "269.361,424.351 415.8,277.912 415.8,240.501 269.361,386.939 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62C9CC"
    },
    d: "M235.157,215.917H104.752c-4.427,0-8.017,3.588-8.017,8.017v203.09c0,4.428,3.589,8.017,8.017,8.017 h130.405c4.427,0,8.017-3.588,8.017-8.017v-203.09C243.173,219.505,239.584,215.917,235.157,215.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62C9CC"
    },
    d: "M235.157,435.04c4.427,0,8.017-3.588,8.017-8.017v-44.359l-52.376,52.376H235.157z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "96.735,424.351 243.173,277.912 243.173,240.501 96.735,386.939 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF9D3C"
    },
    d: "M474.054,451.073H37.946c-4.427,0-8.017,3.588-8.017,8.017v44.894c0,4.428,3.589,8.017,8.017,8.017 h436.109c4.427,0,8.017-3.588,8.017-8.017V459.09C482.071,454.661,478.482,451.073,474.054,451.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2771E"
    },
    d: "M29.929,491.157v12.827c0,4.428,3.589,8.017,8.017,8.017h436.109c4.427,0,8.017-3.588,8.017-8.017 v-12.827H29.929z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/Glass.d70f3c3b554cee52e9db87e652fd7e10.svg";
export { ForwardRef as ReactComponent };